module.exports = __webpack_public_path__ + "img/team.0e67e6b6.jpg";